import styled from "styled-components";

export const DrawerTriger = styled.button`
    cursor: pointer;
    border: 1px solid #d0d0d0;
    line-height: 28px;
    max-width: 200px;
    font-size: 11px;
    //padding: 0 15px;
    padding: ${({ readOnly }) => (readOnly ? '0px' : '0 15px')};
    overflow: hidden; /* 텍스트 넘칠 경우 숨김 */
    text-overflow: ellipsis; /* 말줄임표 추가 */
    white-space: nowrap; /* 한 줄로 표시 */
    height: 28px;
    background: ${({ required, value  }) => (required && value =='선택' ? 'rgb(255, 229, 229)' : 'white')};
    // border: ${({ required, value, readonly  }) => ( required && value == '선택' ? '1px solid rgb(255, 57, 57)' : '1px solid #d0d0d0')};
    border: ${({ readOnly }) => (readOnly ? 'none' : '1px solid #d0d0d0')};
    margin-right: 12px;
    &:hover {
        //border-color: var(--main-bg-color);
        background-color: #f2f2fc;
    }
`;


export const Label = styled.span`
    margin-right: 10px;
    line-height: 28px;
    width: 110px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    margin-left: 10px;
    display: inline-block;
    font-weight: bold;
`;
export const SearchLabel = styled.span`
    
    line-height: 28px;
    width: 80px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    display: inline-block;
    font-weight: bold;
`;
